import { apiClient } from '@/libs/axios';
import type { MutationOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

export type DeleteAdminParams = {
  id: string;
};

export const deleteAdmin = async ({ id }: DeleteAdminParams): Promise<void> => {
  return await apiClient.delete(`admin/${id}`);
};

export function deleteAdminMutationOptions(): MutationOptions<
  void,
  AxiosError,
  DeleteAdminParams
> {
  return {
    mutationFn: deleteAdmin,
  };
}
